import React from "react";
import { IconApp } from "@components/IconApp";
import dayjs from "dayjs";
import { motion } from "framer-motion";

export const checkDisponibility = (eventNew, currentEvents) => {
    let hasConflicts = false;
    let conflictEvents = [];
    let msgErrors = [];

    let en_start = dayjs(eventNew.start);
    let en_end = dayjs(eventNew.end);

    currentEvents.forEach((ce) => {
        let c_start = dayjs(ce.start);
        let c_end = dayjs(ce.end);

        if (
            c_start >= en_start &&
            c_start <= en_end &&
            c_end >= en_start &&
            c_end <= en_end
        ) {
            hasConflicts = true;
            msgErrors.push({
                type: "start_end",
                msg: `Conflicto en entrada y salida nuevo horario: (${en_start.format(
                    "HH:mm"
                )} a ${en_end.format("HH:mm")}) con clase de (${c_start.format(
                    "HH:mm"
                )} a ${c_end.format("HH:mm")})`,
            });

            conflictEvents.push(ce);
        } else if (c_start < en_start && c_end > en_start) {
            hasConflicts = true;
            msgErrors.push({
                type: "start",
                msg: `Conflicto en entrada del nuevo horario: (${en_start.format(
                    "HH:mm"
                )} a ${en_end.format("HH:mm")}) con clase de (${c_start.format(
                    "HH:mm"
                )} a ${c_end.format("HH:mm")})`,
            });
            conflictEvents.push(ce);
        } else if (c_start < en_end && c_end > en_end) {
            hasConflicts = true;
            msgErrors.push({
                type: "end",
                msg: `● Conflicto en salida del nuevo horario: (${en_start.format(
                    "HH:mm"
                )} a ${en_end.format("HH:mm")}) con clase de (${c_start.format(
                    "HH:mm"
                )} a ${c_end.format("HH:mm")})`,
            });
            conflictEvents.push(ce);
        }
    });

    return {
        hasConflicts,
        conflictEvents,
        msgErrors,
    };
};

export const createEvent = (item, date) => {
    const { not_viewed_follow_ups = 0 } = item;

    const title = (
        <div className="text-size-9 position-relative">
            {not_viewed_follow_ups > 0 && (
                <motion.span
                    className="position-absolute"
                    style={{ right: "0", top: "-14px" }}
                    initial={{ scale: 2, rotate: 0 }}
                    animate={{
                        scale: 1,
                        rotate: [0, -15, 15, -10, 10, -5, 5, 0],
                    }}
                    transition={{
                        scale: {
                            duration: 0.5,
                            ease: "easeOut",
                        },
                        rotate: {
                            duration: 1,
                            ease: "easeInOut",
                            repeat: Infinity,
                        },
                    }}
                >
                    <IconApp
                        color="rgba(255, 255, 0)"
                        iconClassName="fas fa-bell text-size-14"
                        description="Tienes nuevos seguimientos"
                    />
                </motion.span>
            )}

            <div className="bg-black bg-opacity-25 rounded p-1 mb-1 d-inline-block">
                <span>
                    {/* <IconApp iconClassName="fas fa-books" />{" "} */}
                    {item?.class?.name}
                    {item.english_sublevel ? ` ${item.english_sublevel}` : ""}
                </span>
            </div>

            <div className="bg-black bg-opacity-25 rounded p-1 d-inline-block">
                <span>
                    {/* <IconApp iconClassName="fas fa-building" />{" "} */}
                    {item?.classroom?.building?.code || "Sin Edificio"}{" "}
                    {item?.classroom?.name || "Sin Aula"}
                </span>
            </div>
        </div>
    );

    return {
        ...item,
        date,
        title,
        start: dayjs(`${date} ${item.start}`).toDate(),
        end: dayjs(`${date} ${item.end}`).toDate(),
    };
};

export const validateConflicts = (
    _date,
    _start,
    _end,
    week_schedule,
    event = null
) => {
    // valida si existen conflictos
    let academic_schedules = week_schedule?.find((ws) => ws.date === _date);
    if (!academic_schedules) {
        return {
            hasConflicts: false,
            conflictEvents: [],
            msgErrors: [],
        };
    }

    let schedulesByDate = academic_schedules.schedule.map((schedule) => ({
        ...schedule,
        start: `${_date} ${schedule?.start}`,
        end: `${_date} ${schedule?.end}`,
    }));

    ///Para saber si esta creando o editando
    if (event) {
        schedulesByDate = schedulesByDate
            // .filter(ce => ce.day === event.day)
            .filter((ce) => ce.id !== event.id);
    }

    return checkDisponibility(
        {
            start: `${_date} ${_start}`,
            end: `${_date} ${_end}`,
        },
        schedulesByDate
    );
};
